var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuickMitsumoriContent',{attrs:{"modeQuickFlg":false},on:{"onUpdateQuickMitsumoriQrInfo":_vm.onUpdateQuickMitsumoriQrInfo,"onConfirmExit":_vm.onConfirmExit}})}
var staticRenderFns = []

export { render, staticRenderFns }